<template>
<div class="p-generated">
  <div class="p-generated__header-done">
    <Text className="c-text--bold" text="サムネイル画像が生成されました"></Text>
  </div>
  <div class="p-generated__wrap">
    <div v-if="thumbnailType === 1" id="generatedAsDom" class="p-generated__content" :style="style">
      <div class="p-generated__content-p1--sp">
        <Img v-if="createThumbnailBy === 'url'"  className="c-img__adjust" :src="screenShotSp"></Img>
        <Img v-else  className="c-img" :src="prevFileSp"></Img>
      </div>
      <div class="p-generated__content-p1--pc">
        <Img v-if="createThumbnailBy === 'url'"  className="c-img__adjust" :src="screenShotPc"></Img>
        <Img v-else  className="c-img" :src="prevFilePc"></Img>
      </div>
      <Img class="c-img__pos00--scale" :src="src.mockP1"></Img>
    </div>
    <div v-else-if="thumbnailType === 2" id="generatedAsDom" class="p-generated__content" :style="style">
      <div class="p-generated__content-p2--sp">
        <Img v-if="createThumbnailBy === 'url'"  className="c-img__adjust" :src="screenShotSp"></Img>
        <Img v-else  className="c-img" :src="prevFileSp"></Img>
      </div>
      <div class="p-generated__content-p2--pc">
        <Img v-if="createThumbnailBy === 'url'"  className="c-img__adjust" :src="screenShotPc"></Img>
        <Img v-else  className="c-img" :src="prevFilePc"></Img>
      </div>
      <Img class="c-img__pos00--scale" :src="src.mockP2"></Img>
    </div>
  </div>
  <div class="p-generated__btn-wrapper">
    <a class="p-generated__btn-download" :href="worksThumbnailBase64" id="download" download="works_thumbnail.png">
      <Button className="c-btn__primary--l-download gtm-save" :id="worksThumbnailBase64" text="保存する"></Button>
    </a>
    <Button className="c-btn__border--l" text="やりなおす" @click="modalClose"></Button>
  </div>
</div>
</template>

<script>
import Store from '../../store/index.js'
import Text from '@/components/atoms/Text.vue'
import Button from '@/components/atoms/Button.vue'
import Img from '@/components/atoms/Img.vue'

export default {
  components: {
    Text,
    Button,
    Img
  },
  props: {
    createThumbnailBy: String
  },
  data () {
    return {
      src: {
        mockP1: Store.state.mockup.p1,
        mockP2: Store.state.mockup.p2
      },
      style: Store.state.bgStyle
    }
  },
  computed: {
    thumbnailType () {
      let type = Number
      Store.state.thumbnailType.p1 ? type = 1 : type = 2
      return type
    },
    prevFilePc () {
      if (Store.state.file.pc) {
        return window.URL.createObjectURL(Store.state.file.pc)
      } else {
        return null
      }
    },
    prevFileSp () {
      if (Store.state.file.sp) {
        return window.URL.createObjectURL(Store.state.file.sp)
      } else {
        return null
      }
    },
    screenShotPc () {
      if (Store.state.screenShot.pc) {
        return Store.state.screenShot.pc
      } else {
        return null
      }
    },
    screenShotSp () {
      if (Store.state.screenShot.sp) {
        return Store.state.screenShot.sp
      } else {
        return null
      }
    },
    worksThumbnailBase64 () {
      return Store.state.worksThumbnailBase64
    }
  },
  methods: {
    modalClose () {
      Store.commit('handleModalCloseAll')
    }
  }
}

</script>

<style lang="scss" scoped>
.p-generated {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__header-done {
    margin-bottom: 20px;
    padding-left: 2.5rem;
    position: relative;
    &::before {
      content: '';
      width: 2rem;
      height: 2rem;
      background: url('/assets/img/ic_check.png');
      background-size: cover;
      position: absolute;
      left: 0;
    }
  }
  &__wrap {
    width: 600/1280*100vw;
    height: 400/1280*100vw;
    overflow: scroll;
    @include media-queries-sp {
      width: 295/375*100vw;
      height: 197/375*100vw;
    }
  }
  &__content {
    width: 1200/1280*100vw;
    height: 800/1280*100vw;
    transform-style: preserve-3d;
    perspective: 2000/1280*100vw;
    position: relative;
    &-p1 {
      &--pc {
        width: 345/1280*100vw;
        height: 216/1280*100vw;
        overflow: hidden;
        transform: scale(1.86);
        transform-origin: left top;
        position: absolute;
        top: 23.2%;
        left: 15.2%;
      }
      &--sp {
        width: 80/1280*100vw;
        height: 156/1280*100vw;
        overflow: hidden;
        border-radius: 5px;
        transform: scale(1.95);
        transform-origin: left top;
        position: absolute;
        top: 41.6%;
        left: 79.1%;
      }
    }
    &-p2 {
      &--pc {
        width: 345/1280*100vw;
        height: 216/1280*100vw;
        overflow: hidden;
        transform: rotateX(16deg) rotateY(-31.9deg) rotateZ(4.9deg) scale(1.66);
        transform-origin: left top;
        position: absolute;
        top: 24%;
        left: 42%;
      }
      &--sp {
        width: 85/1280*100vw;
        height: 175/1280*100vw;
        overflow: hidden;
        border-radius: 10px;
        transform: rotateX(34deg) rotateY(33.5deg) rotateZ(-24.6deg) translateZ(150/1280*100vw) scale(1.75);
        transform-origin: left top;
        position: absolute;
        top: 54.2%;
        left: 5.42%;
        @include media-queries-sp {
          border-radius: 0 0 3px 0;
        }
      }
    }
  }
  &__btn-wrapper {
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    @include media-queries-sp {
      display: block;
    }
  }
  &__btn-download {
    margin: 0 auto;
  }
}
</style>
